module.exports = __webpack_public_path__ + "static/img/20180414165955.c3fc123f.jpg";